import { Route } from '@angular/router';
import { SurveysListPageComponent } from './surveys-list-page/surveys-list-page.component';
import { AuthGuard } from '../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../guards/is-completed-user-data.guard';
import { SurveyPageComponent } from './survey-page/survey-page.component';
import { SurveyResolver } from '../../resolvers/survey.resolver';

export const surveysRoutes: Route[] = [
  {
    component: SurveysListPageComponent,
    path: 'konsultacje-spoleczne'
  },
  {
    component: SurveyPageComponent,
    path: 'konsultacje-spoleczne/:surveyId',
    resolve: {
      survey: SurveyResolver
    }
  }
];
